module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "ch03"
    }
  }, [_vm._v("chapter three")])]), _c('a', {
    attrs: {
      "id": "ch03"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("I")]), _vm._v(" practically flew out into the living room holding the bank statement above my head. Mom was rubbing her feet and watching a rerun of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Who Wants to Be a Millionaire")]), _vm._v(" while rereading one of her historical romances. My mouth opened and closed, but I couldn’t form any words. I wanted to demand we call the police. I wanted to scream I’d been robbed, but deep down I already knew the truth. I’d opened that account when I was a kid. I was too young then to have an account on my own; there was only one other name on it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom sat up when she saw me. “Oh. I was going to talk to you about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell me you didn’t take my money.” I held the statement in front of me like a shield.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch03"
    }
  }, [_vm._v("“Your dad needed it. You know the court-appointed legal ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("assistance isn’t worth a nickel. For your dad to stand a chance at early release, we need a halfway decent lawyer in his corner, and the lawyer needed more money to keep working. Then last week when we had that big rainstorm, I saw the roof was leaking again in the bathroom.” Mom shrugged like she couldn’t even remember all the various amounts of money she owed. “The bank wasn’t going to lend me anything more.”")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“So you stole from me?” I screeched.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mom stood up. “You need to calm down.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It felt like the top of my skull was going to blow off. “Calm down? Are you kidding? You took my college money.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sadie, I know you needed that money for school, but I needed that money for our family. Yes, school is important, but so is keeping a roof over our heads and getting your dad back. You keep talking about ‘your’ money, but you forget that we’re a family, and that means we have to help each other out. You live here and I rarely ask you to chip in for costs.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I took a step back. I couldn’t believe her. “You’re my "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("mom")]), _vm._v(". It’s not like you’re doing me some big favor by letting me stay here. Sorry that you had me, and then you had to do all sorts of horrible things like feed me and provide me with basic housing and clothes.” I motioned around the trailer. “And let me be sure to point out what a great job you’ve done, by the way, of providing me with everything my heart has ever dreamed about.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("dare")]), _vm._v(" imply I’m not doing everything I can,” Mom snapped. “I work six days a week at that hotel.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("“That money was my way out of here.” I could hear the tears in my voice, and I swallowed them back down. “This was my chance to do better.”")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom walked into the kitchen, yanked out the rolls, and started to make sandwiches. She slathered the bread with generic-brand mayonnaise and deli ham. “Don’t start. This isn’t about you going to school. You could go to college in Seattle for free. This is about you going to some fancy school in California so you can feel important. You can still enroll in Seattle. You can live here and keep your job at the hotel on the weekends. If it still matters so much, then you can go away next year.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked around the room as if I expected someone to jump in and point out how twisted my mom’s thinking was. “You can’t be serious.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You think you’re the only one who wants better? "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I")]), _vm._v(" don’t want to keep working at the hotel, and I’ve been there over twenty years. I don’t want to live in this trailer either. I’m sorry your life hasn’t been all sunshine, roses, and unicorns. Welcome to the real world, honey. This family needed that money and you’re a part of this family. Sometimes you don’t get what you want.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re acting like you did nothing wrong. You knew it was wrong or you would have asked me, but instead you just took it. You stole it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom slapped the knife she had been using to spread mayonnaise down on the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You stole that money first, so get off your frickin’ high horse.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("I dropped the statement and stared at her.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughed when she saw my face. “What? You think I don’t know what you and Brendan are up to all the time? You’re a real chip off the block. Your dad should be proud.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m nothing like him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why, because you haven’t got caught like he has? Maybe you’re better at it than he is, but a con artist is a con artist. Your bluffing some rich boys out of a few dollars with a card trick isn’t any better than your dad fencing hot car parts. You grew up with your dad; what else were you supposed to do? You lie down with dogs, you get up with fleas.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m not like him,” I said. She raised an eyebrow at me. “Yes, I pulled a few cons, but I did it because I needed money for school. There was a good reason for what I did.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Even the devil has an excuse for doing wrong. You’re not special there. The truth is, the villain of every story actually thinks he’s the hero. Your dad has a good reason too. He takes care of this family. It’s not like he’s going to get some fancy job making big money. He does the best he can. We’re all doing the best we can.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My entire body was shaking as if I was attached to a live wire. I was either going to melt down in full-on tears or start throwing things.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Mom sighed and rubbed her forehead. “Sadie, I’m sorry. I don’t want to fight with you, and I don’t think you’re a bad kid. I wish we’d done better by you, but your dad and I have done ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("our best. I promise, even though it might feel like it, your world isn’t falling apart. This is a hurdle, and while I wish I could save you from every hard thing that is going to happen in your life, I can’t. You’re going to have to learn how to pick yourself up when the world knocks you down.” She stepped out from behind the kitchen counter and took a step toward me, as if she was going in for a hug.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I stepped back quickly out of her reach. “The world didn’t knock me down; you did. You’re not trying to save me from a hurdle; you’re throwing them out in front of me. I figured out early I’d better do whatever I had to, because no one in this family was going to help me.” I yanked open the door. “And you know the biggest wrong of all, Mom? You apparently knew I was up to something all this time and you never even tried to stop me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I slammed the screen door behind me and took off.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c1b682c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 75
// module chunks = 0